<template>
  <div class="disabled-page">
    <h2>Temporariamente indisponível</h2>
    <iframe
      src="https://giphy.com/embed/4jn0ocypTMI6rTKS9Y"
      width="480"
      height="405"
      frameBorder="0"
      class="giphy-embed"
      allowFullScreen
    ></iframe>
    <p>Entre em contato com os administradores</p>
  </div>
</template>
<script>
export default {
  name: 'disabled'
};
</script>
<style scoped>
.disabled-page {
  width: 100%;
  height: 100vh;
  text-align: center;
  margin-top: 40px;
  background-color: white;
}
</style>
